/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SendMailSouscriptionRecapMutation from '../graphql/mutations/SendMailSouscriptionRecapMutation.js';

export const useSendMailSouscriptionRecapMutation = () => {
  return useCommitMutation(SendMailSouscriptionRecapMutation, { dataProp: 'SendMailSouscriptionRecap_M_souscription_recap' });
};

export default useSendMailSouscriptionRecapMutation;
